module.exports = __webpack_public_path__ + "Roboto-Light.a2b8c641546c0e5a95e2.ttf";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/roboto-fontface/fonts/roboto/Roboto-Light.ttf
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Light.ttf
// module chunks = styles